import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';
import { defineAsyncComponent } from 'vue';

const contactsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.contacts_trans',
  route: { name: 'contacts' },
});

const blockListCrumb = {
  label: 'global.sidebar.block_trans',
  route: { name: 'c-block' },
};

const segmentsCrumb = {
  label: 'global.sidebar.segments_trans',
  route: { name: 'c-segments' },
};

const contacts_routes = [
  {
    path: '/contacts',
    name: 'contacts',
    meta: {
      header: {
        title: 'GLOBAL.NAVS.contacts_trans',
        icon: 'bvi-contacts',
      },
      sidebar: [
        {
          title: 'global.sidebar.all_contacts_trans',
          route: { name: 'c-contacts' },
          permissions: 'read-contacts',
        },
        {
          title: 'global.sidebar.block_trans',
          route: { name: 'c-block' },
          permissions: 'read-contacts',
        },
        {
          title: 'global.sidebar.segments_trans',
          items: [defineAsyncComponent(() => import('./Components/sidebar-filtration/segments/SegmentsList.vue'))],
          action: defineAsyncComponent(() => import('./Components/sidebar-filtration/segments/AddSegmentButton.vue')),
          permissions: 'read-contacts',
        },
        {
          title: 'global.sidebar.tags_trans',
          items: [defineAsyncComponent(() => import('./Components/sidebar-filtration/tags/TagsList.vue'))],
          action: defineAsyncComponent(() => import('./Components/sidebar-filtration/tags/AddTagButton.vue')),
          permissions: 'read-contacts',
        },
      ],
    },
    children: [
      {
        path: 'list',
        name: 'c-contacts',
        component: () => import('@/views/System/Contacts/ContactsList.vue'),
        meta: {
          permissions: 'read-contacts',
          breadcrumbs: contactsBreadcrumbs(),
        },
      },
      {
        path: 'add',
        name: 'c-contacts-add',
        component: () => import('@/views/System/Contacts/ContactsForm.vue'),
        meta: {
          permissions: 'read-contacts',
          breadcrumbs: contactsBreadcrumbs(),
        },
      },
      {
        path: ':id',
        name: 'c-contacts-show',
        component: () => import('@/views/System/Contacts/ContactDetails.vue'),
        meta: {
          permissions: 'read-contacts',
          breadcrumbs: contactsBreadcrumbs(),
        },
      },
      {
        path: 'edit/:id',
        name: 'c-contacts-edit',
        component: () => import('@/views/System/Contacts/ContactsForm.vue'),
        meta: {
          permissions: 'update-contacts',
          breadcrumbs: contactsBreadcrumbs(),
        },
      },
      {
        path: 'block',
        name: 'c-block',
        component: () => import('@/views/System/Contacts/BlockList.vue'),
        meta: {
          permissions: 'read-contacts',
          isBlock: true,
          breadcrumbs: contactsBreadcrumbs(blockListCrumb),
        },
      },
      {
        path: 'block/:id',
        name: 'c-block-details',
        component: () => import('@/views/System/Contacts/ContactDetails.vue'),
        meta: {
          permissions: 'read-contacts',
          breadcrumbs: contactsBreadcrumbs(blockListCrumb, {
            label: 'contacts.show.title_trans',
            route: { name: 'c-block-details' },
          }),
        },
      },
      {
        path: 'segments',
        children: [
          {
            path: ':segmentId',
            name: 'c-segments',
            component: () => import('@/views/System/Contacts/ContactsList.vue'),
            meta: {
              permissions: 'read-contacts',
              breadcrumbs: contactsBreadcrumbs(segmentsCrumb),
            },
          },
          {
            path: 'edit/:segmentId',
            name: 'c-segment-edit',
            component: () => import('@/views/System/Contacts/ContactsList.vue'),
            meta: {
              permissions: 'read-contacts',
              breadcrumbs: contactsBreadcrumbs(segmentsCrumb),
            },
          },
        ],
      },
      {
        path: 'tags/:tagId',
        name: 'c-contacts-tags',
        component: () => import('@/views/System/Contacts/ContactsList.vue'),
        meta: {
          permissions: 'read-contacts',
          breadcrumbs: contactsBreadcrumbs({
            label: 'global.sidebar.tags_trans',
            route: { name: 'c-contacts-tags' },
          }),
        },
      },
      {
        path: 'import-contacts',
        name: 'c-import-contacts',
        component: () => import('@/views/System/Contacts/Components/ImportStepper/StepperWrapper.vue'),
        meta: {
          permissions: 'import-contacts',
          breadcrumbs: contactsBreadcrumbs({
            label: 'contacts.import.title_trans',
            route: { name: 'c-import-contacts' },
          }),
        },
      },
    ],
  },
];

export default contacts_routes;
